var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-wrap"},[_c('el-card',{staticClass:"agreement-card",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("喜铺破包子会员卡及会员服务活动条款与条件须知")])]),_c('div',{staticClass:"scroll-box"},[_c('div',{staticClass:"article",domProps:{"innerHTML":_vm._s(_vm.agreementText)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }